import { css as c, LitElement as b, html as n, nothing as h } from "lit";
import { property as p, customElement as d } from "lit/decorators.js";
import { classMap as u } from "lit/directives/class-map.js";
import { b as m, f as v } from "./styles-scZ6dVz-.js";
import { b as f } from "./events-CkEPl0SM.js";
var w = Object.defineProperty, y = Object.getOwnPropertyDescriptor, l = (t, e, g, o) => {
  for (var r = o > 1 ? void 0 : o ? y(e, g) : e, s = t.length - 1, i; s >= 0; s--)
    (i = t[s]) && (r = (o ? i(e, g, r) : i(r)) || r);
  return o && r && w(e, g, r), r;
};
let a = class extends b {
  constructor() {
    super(...arguments), this.page = 1, this.totalPages = 1, this.size = "md", this.showFirstLast = !1, this.siblings = 1, this.showInfo = !1, this.simple = !1, this.compact = !1;
  }
  get pages() {
    const { page: t, totalPages: e, siblings: g } = this, o = [], r = Math.max(2, t - g), s = Math.min(e - 1, t + g);
    o.push(1), r > 2 && o.push("ellipsis");
    for (let i = r; i <= s; i++)
      i !== 1 && i !== e && o.push(i);
    return s < e - 1 && o.push("ellipsis"), e > 1 && o.push(e), o;
  }
  get infoText() {
    if (this.totalItems !== void 0 && this.pageSize !== void 0) {
      const t = (this.page - 1) * this.pageSize + 1, e = Math.min(this.page * this.pageSize, this.totalItems);
      return `${t}-${e} of ${this.totalItems}`;
    }
    return `Page ${this.page} of ${this.totalPages}`;
  }
  handlePageChange(t) {
    t < 1 || t > this.totalPages || t === this.page || (this.page = t, f(this, "ark-change", { page: t }));
  }
  goToFirst() {
    this.handlePageChange(1);
  }
  goToPrevious() {
    this.handlePageChange(this.page - 1);
  }
  goToNext() {
    this.handlePageChange(this.page + 1);
  }
  goToLast() {
    this.handlePageChange(this.totalPages);
  }
  render() {
    const t = {
      container: !0,
      [this.size]: !0,
      simple: this.simple,
      compact: this.compact
    }, e = n`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m15 18-6-6 6-6"/>
      </svg>
    `, g = n`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m9 18 6-6-6-6"/>
      </svg>
    `, o = n`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m11 17-5-5 5-5"/><path d="m18 17-5-5 5-5"/>
      </svg>
    `, r = n`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m6 17 5-5-5-5"/><path d="m13 17 5-5-5-5"/>
      </svg>
    `;
    return n`
      <nav part="container" class=${u(t)} aria-label="Pagination">
        ${this.showInfo ? n`<span part="info" class="info">${this.infoText}</span>` : h}

        <div part="nav" class="nav">
          ${this.showFirstLast ? n`
                <button
                  part="button button-first"
                  class="button arrow-button focus-ring"
                  ?disabled=${this.page === 1}
                  @click=${this.goToFirst}
                  aria-label="Go to first page"
                >
                  ${o}
                </button>
              ` : h}

          <button
            part="button button-prev"
            class="button arrow-button focus-ring"
            ?disabled=${this.page === 1}
            @click=${this.goToPrevious}
            aria-label="Go to previous page"
          >
            ${e}
          </button>

          ${this.simple ? h : n`
                <span class="page-numbers">
                  ${this.pages.map(
      (s, i) => s === "ellipsis" ? n`<span part="ellipsis" class="ellipsis" key="ellipsis-${i}">…</span>` : n`
                          <button
                            part="button"
                            class=${u({
        button: !0,
        active: s === this.page,
        "focus-ring": !0
      })}
                            @click=${() => this.handlePageChange(s)}
                            aria-label=${`Go to page ${s}`}
                            aria-current=${s === this.page ? "page" : h}
                          >
                            ${s}
                          </button>
                        `
    )}
                </span>
              `}

          <button
            part="button button-next"
            class="button arrow-button focus-ring"
            ?disabled=${this.page === this.totalPages}
            @click=${this.goToNext}
            aria-label="Go to next page"
          >
            ${g}
          </button>

          ${this.showFirstLast ? n`
                <button
                  part="button button-last"
                  class="button arrow-button focus-ring"
                  ?disabled=${this.page === this.totalPages}
                  @click=${this.goToLast}
                  aria-label="Go to last page"
                >
                  ${r}
                </button>
              ` : h}
        </div>
      </nav>
    `;
  }
};
a.styles = [
  m,
  v,
  c`
      :host {
        display: block;
      }

      .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--r5-space-4);
        flex-wrap: wrap;
      }

      .info {
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
        white-space: nowrap;
      }

      .nav {
        display: flex;
        align-items: center;
        gap: var(--r5-pagination-gap, var(--r5-space-1));
      }

      .button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: var(--r5-pagination-button-size);
        height: var(--r5-pagination-button-size);
        padding: 0 var(--r5-space-2);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-md);
        background-color: var(--r5-surface);
        color: var(--r5-text);
        font-size: var(--r5-text-sm);
        font-family: inherit;
        font-variant-numeric: tabular-nums;
        cursor: pointer;
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .button:hover:not(:disabled) {
        background-color: var(--r5-bg-muted);
        border-color: var(--r5-color-neutral-300);
      }

      .button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      .button.active {
        background-color: var(--r5-color-primary-600);
        border-color: var(--r5-color-primary-600);
        color: white;
      }

      .button.active:hover {
        background-color: var(--r5-color-primary-700);
        border-color: var(--r5-color-primary-700);
      }

      .ellipsis {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: var(--r5-pagination-button-size);
        height: var(--r5-pagination-button-size);
        color: var(--r5-text-muted);
        font-size: var(--r5-text-sm);
        user-select: none;
      }

      .arrow-button {
        padding: 0;
        min-width: var(--r5-pagination-button-size);
      }

      .arrow-button svg {
        width: 1rem;
        height: 1rem;
      }

      /* Sizes */
      .sm {
        --r5-pagination-button-size: 1.75rem;
      }

      .md {
        --r5-pagination-button-size: 2rem;
      }

      .lg {
        --r5-pagination-button-size: 2.5rem;
      }

      /* Compact mode */
      .compact .info {
        display: none;
      }

      /* Simple mode - only prev/next */
      .simple .page-numbers {
        display: none;
      }
    `
];
l([
  p({ type: Number })
], a.prototype, "page", 2);
l([
  p({ type: Number, attribute: "total-pages" })
], a.prototype, "totalPages", 2);
l([
  p({ type: Number, attribute: "total-items" })
], a.prototype, "totalItems", 2);
l([
  p({ type: Number, attribute: "page-size" })
], a.prototype, "pageSize", 2);
l([
  p({ type: String, reflect: !0 })
], a.prototype, "size", 2);
l([
  p({ type: Boolean, attribute: "show-first-last" })
], a.prototype, "showFirstLast", 2);
l([
  p({ type: Number })
], a.prototype, "siblings", 2);
l([
  p({ type: Boolean, attribute: "show-info" })
], a.prototype, "showInfo", 2);
l([
  p({ type: Boolean })
], a.prototype, "simple", 2);
l([
  p({ type: Boolean })
], a.prototype, "compact", 2);
a = l([
  d("ark-pagination")
], a);
export {
  a as A
};
//# sourceMappingURL=ark-pagination-BWXl2Har.js.map
